import { InjectionToken, } from '@angular/core';
import * as firebase from 'firebase/app';
export var FirebaseAppConfigToken = new InjectionToken('FirebaseAppConfigToken');
var FirebaseApp = (function () {
    function FirebaseApp() {
    }
    return FirebaseApp;
}());
export { FirebaseApp };
export function _firebaseAppFactory(config, appName) {
    try {
        if (appName) {
            return firebase.initializeApp(config, appName);
        }
        else {
            return firebase.initializeApp(config);
        }
    }
    catch (e) {
        return firebase.app(null);
    }
}
//# sourceMappingURL=firebase.app.module.js.map


//////////////////
// WEBPACK FOOTER
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/~/angularfire2/app/firebase.app.module.js
// module id = ../../../../angularfire2/app/firebase.app.module.js
// module chunks = 3